import { FloraButton } from '@grupoboticario/flora-react';
import { SocialWhatsappIcon } from '@grupoboticario/flora-react-icons';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import config from 'config';
import { getWhatsappLink } from 'helpers';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth';

import type { ActionsParams } from '../Actions';

export const OpenWppHelpCentral = ({ hierarchy }: ActionsParams) => {
  const navigate = useNavigate();
  const whatsappLink = getWhatsappLink(
    config.communication.whatsapp || '',
    config.communication.message
  );

  const handleOnClick = () => {
    window.open(whatsappLink, '_blank', 'noopener, noreferrer');
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
    navigate('/perfil', { replace: true });
  };

  return (
    <FloraButton
      autotagging-flora='on'
      data-flora='button'
      data-flora-text='conversar-com-o-atendimento'
      hierarchy={hierarchy}
      rel='noopener noreferrer'
      has='iconLeft'
      icon={<SocialWhatsappIcon size='16' aria-hidden />}
      onClick={handleOnClick}
    >
      <ResponsiveFloraTypography fontWeight='bold'>
        Conversar com o atentimento
      </ResponsiveFloraTypography>
    </FloraButton>
  );
};
